import { ArrowLeft } from '@recruit-robin/robin-theme/web-icons';
import { useContext } from 'react';

import { useFeatureToggles } from '@/shared/legacy/hooks/useFeatureToggles';
import { RobinJrAppToggle } from '@/shared/ui/robin-jr-app-toggle';
import CampaignList from 'components/ui/molecules/CampaignList/CampaignList';
import { CampaignListHeader } from 'components/ui/molecules/CampaignList/CampaignListHeader';
import { default as Logo } from 'shared/legacy/components/Logo';
import { SidebarOverlayFixedContext } from 'shared/legacy/contexts/SidebarOverlayFixedContext';
import { useStyles } from './SidebarOverlayFixed.styles';

const SidebarOverlayFixed = () => {
  const { setIsOpen, setSidebarRef } = useContext(SidebarOverlayFixedContext);
  const classes = useStyles();
  const { isFeatureToggleEnabled } = useFeatureToggles();

  const isRobinJrAppToggleEnabled = isFeatureToggleEnabled((f) => f.ROBIN_JR_CHAT);

  return (
    <div ref={setSidebarRef} css={classes.root}>
      <div css={classes.overlayHeader}>
        <Logo variant={'text'} />

        {isRobinJrAppToggleEnabled && <RobinJrAppToggle />}

        <div css={classes.overlayArrow} onClick={() => setIsOpen(false)}>
          <ArrowLeft height={24} />
        </div>
      </div>

      <CampaignListHeader />

      <div css={classes.body}>
        <div css={classes.overlayHr} />
        <div css={classes.overlayCampaignList}>
          <CampaignList />
        </div>
      </div>
    </div>
  );
};

export default SidebarOverlayFixed;
